module.exports = __webpack_public_path__ + "img/kyo_15s_novembre_2021.ab478732.jpg";